export enum QuestionType {
    SINGLE_CHOICE = "SINGLE_CHOICE",
    MULTI_SELECT = "MULTI_SELECT",
}

export enum QuestionnaireStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}

export interface QuestionOption {
    id: number;
    displayText: string;
    orderIndex: number;
    scoreValue: number;
}

export interface Question {
    id: number;
    text: string;
    order_index: string;
    question_type: QuestionType;
    min_value: number;
    max_value: number;
    options: QuestionOption[];
}

export interface ScoreRange {
    id: number;
    minScore: number;
    maxScore: number;
    interpretation: string;
}

export interface QuestionnaireResponse {
    id: number;
    name: string;
    description: string;
    status: QuestionnaireStatus;
    imagePath: string;
    questions: Question[];
    scoreRanges: ScoreRange[];
}
